export const DEFAULT_NON_VIDEO_PAGE_DURATION = 5;
